<template>
  <div class="contents-box row">
    <div class="contents-lists">
      <div v-for="(txt,index) in txts" :key="index" class="contents-list">
        <h3 class="title-text">{{$t(`service.${txt.title}`)}}</h3>
        <p>{{txt.text}}</p>
      </div>
    </div>

    <!--<div class="col-md-5 col-sm-5 prodect-wrap">-->
      <!--<img :src="imgUrl" alt="">-->
    <!--</div>-->
  </div>
</template>

<script>
    export default {
        name: '',
        data () {
            return {
              txts:[
                // {title:'一个平台',text:'开放的、大数据平台'},
                // {title:'四大系统',text:'健康检测系统,健康评估系统,档案管理系统,健康促进系统'},
                // {title:'五种服务',text:'体检服务,社区健康服务,用户健康档案管理服务,用户健康、慢病评估服务,个人健康促进管理服务'}
                { title:'tab1_1',route:'/Service/product_list1',from:'product_list1',flag:'product_list1' },
                { title:'tab1_2',route:'/Service/product_list2',from:'sservice' },
                { title:'tab1_3',route:'/Service/product_list3',from:'sservice' },
                { title:'tab1_4',route:'/Service/product_list4',from:'sservice' },
                { title:'tab1_5',route:'/Service/product_list5',from:'sservice' },
                { title:'tab1_6',route:'/Service/product_list6',from:'sservice' },
                { title:'tab1_7',route:'/Service/product_list7',from:'sservice' },
                { title:'tab1_8',route:'/Service/product_list8',from:'sservice' },
                { title:'tab1_9',route:'/Service/product_list9',from:'sservice' },
                { title:'tab1_10',route:'/Service/product_list10',from:'sservice' },
                { title:'tab1_11',route:'/Service/product_list11',from:'sservice' }
              ],
              imgUrl:require('../../../src/assets/images/pro_cp.png')
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// sservice.vue?3ea4d412